<template>
  <b-card :title="collection.name">
    <b-card-text>{{ collection.info }}</b-card-text>
    <b-button @click="showCollection()" variant="primary" size="sm">Pogledaj</b-button>
  </b-card>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: ["collection"],
  date() {
    return {};
  },
  methods: {
    ...mapMutations({ setCollection: "resources/setCollection" }),
    showCollection() {
      this.setCollection(this.collection);
      this.$router.push({
        name: "collection",
        params: { uuid: this.collection.uuid }
      });
    }
  }
};
</script>

<style>
</style>